import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=0b5d6bbe&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=ts&"
export * from "./IconCheck.vue?vue&type=script&lang=ts&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=0b5d6bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d6bbe",
  null
  
)

export default component.exports